<ng-template #noproductthumb>
    <!-- CREATE NEW PRODUCT -->
    <ng-container *ngIf="target === 'CREATE'">
        <upp-thumb uppDataid="product-create-button" 
            icon="add-outline" 
            [title]="tr('@place_product_create')" 
            (click)="OnSelect()"
        ></upp-thumb>
    </ng-container>

    <!-- SORT GO TO LEVEL UP -->
    <ng-container *ngIf="target === 'SORT' || target === 'SELECT'">
        <upp-thumb uppDataid="product-levelup-button" 
            icon="arrow-up" 
            [title]="tr('@place_product_levelup')"
            (click)="OnSelect()"
        ></upp-thumb>
    </ng-container>

    <!-- ADD A VARIOUS ITEM -->
    <ng-container *ngIf="target === 'OTHER'">
        <upp-thumb uppDataid="product-other-button" 
            icon="help" 
            [title]="tr('@place_product_various')"
            (click)="OnSelect()"
        ></upp-thumb>
    </ng-container>

    <!-- SEARCH BY CODE -->
    <ng-container *ngIf="target === 'PRDNO'">
        <upp-thumb uppDataid="product-prdno-button"
            icon="keypad-outline"
            color="dark"
            [title]="tr('@place_product_search_by_code')"
            (click)="OnSelect()"
        ></upp-thumb>
    </ng-container>
</ng-template>

<ng-template #productthumb let-product="product">
    <!-- DRAW THE PRODUCT -->
    <ng-container *ngIf="product.IsFamily !== true">
        <upp-thumb uppTouch [uppDataid]="thumbtype + '-' + thumbname + '-thumb'"
            [card]="product.photo"
            [title]="tr(product.name)" 
            (TouchClick)="OnSelect()"
            (TouchStart)="OnPressed(true)"
            (TouchLeave)="OnPressed(false)"
        ></upp-thumb>

        <ng-container *ngIf="product.IsProduct === true">
            <ion-chip *ngIf="product.code" class="code">
                <ion-label>#{{product.code}}</ion-label>
            </ion-chip>
            <ion-chip class="price" uppDataid="product-thumb-price-info">
                <ng-container *ngIf="product.IsMarket === true">
                    <ion-label>
                        {{tr('@place_product_marketprice_brief')}}
                    </ion-label> 
                </ng-container>
                <ng-container *ngIf="product.IsMarket !== true">
                    <ion-label class="price" *ngIf="ThumbPrice as price">
                        <span class="small">{{tr("@place_price_starting_from")}}:</span>
                        {{price.int}}<span class="decimal">,{{price.dec}}</span>{{tr('@currency')}}<span *ngIf="product.IsWeighted" class="decimal">/{{tr('@kilograms')}}</span>
                    </ion-label>
                </ng-container>
            </ion-chip>
        </ng-container>

        <ng-container *ngIf="product.IsGroup">
            <ion-chip class="group">
                <ion-label>
                    {{tr('@place_group_selected_chip')}}
                </ion-label>
                <ion-badge uppDataid="product-thumb-purchased-info">{{product.ProductsLength}}</ion-badge>
            </ion-chip>            
        </ng-container>
    </ng-container>

    <!-- DRAW THE FAMILY -->
    <ng-container *ngIf="product.IsFamily === true">
        <upp-thumb uppTouch [uppDataid]="thumbtype + '-' + thumbname + '-thumb'" shape="round"
            [card]="product.photo"            
            [title]="tr(product.name)" 
            (TouchClick)="OnSelect()"
            (TouchStart)="OnPressed(true)"
            (TouchLeave)="OnPressed(false)"
        ></upp-thumb>  

        <ion-chip class="group">
            <ion-label>
                {{tr('@place_group_selected_chip')}}
            </ion-label>
            <ion-badge uppDataid="product-thumb-purchased-info">{{product.ProductsLength}}</ion-badge>
        </ion-chip>            
    </ng-container>
</ng-template>

<ng-template #directthumb let-product="product">
    <ng-container *ngIf="product">
        <upp-thumb uppTouch *ngIf="IsDirectProduct !== true" [uppDataid]="thumbtype + '-' + thumbname + '-thumb'"
            [card]="product.photo"
            [title]="tr(product.name)" 
            (TouchClick)="OnSelect()"
            (TouchStart)="OnPressed(true)"
            (TouchLeave)="OnPressed(false)"
        ></upp-thumb>        
        <upp-thumb uppTouch *ngIf="IsDirectProduct === true" [uppDataid]="thumbtype + '-' + thumbname + '-thumb'" color="warning"
            [card]="product.photo"
            [title]="tr('@place_product_direct')" 
            (TouchClick)="OnSelect()"
            (TouchStart)="OnPressed(true)"
            (TouchLeave)="OnPressed(false)"
        ></upp-thumb>

        <ion-chip *ngIf="product.code" class="code">
            <ion-label>#{{product.code}}</ion-label>
        </ion-chip>
        <ion-chip class="price" uppDataid="product-thumb-price-info">
            <ng-container *ngIf="product.IsMarket === true">
                <ion-label>
                    {{tr('@place_product_marketprice_brief')}}
                </ion-label> 
            </ng-container>
            <ng-container *ngIf="product.IsMarket !== true">
                <ion-label class="price" *ngIf="ThumbPrice as price">
                    {{price.int}}<span class="decimal">,{{price.dec}}</span>{{tr('@currency')}}<span *ngIf="product.product.IsWeighted" class="decimal">/{{tr('@kilograms')}}</span>
                </ion-label>
            </ng-container>
        </ion-chip>
    </ng-container>
</ng-template>

<ng-template #createicons let-product="product">
    <ng-container *ngIf="product.IsGroup === true">
        <ion-icon class="floating top left warning" name="grid-outline"></ion-icon>
        <ion-icon *ngIf="!product.IsCatalog" uppDataid="product-thumb-group-edit"             
            class="floating top right" 
            name="settings-outline" 
            [ngClass]="(product.IsAvailable) ? 'warning' : 'danger'" 
            (click)="OnModify()"
        ></ion-icon>
    </ng-container>

    <ng-container *ngIf="product.IsFamily === true">
        <ion-icon class="floating top left warning" name="flash-outline"></ion-icon>
        <ion-icon *ngIf="!product.IsCatalog" uppDataid="product-thumb-group-edit"
            class="floating top right dark" 
            name="settings-outline" 
            [ngClass]="(product.IsAvailable) ? 'warning' : 'danger'" 
            (click)="OnModify()"
        ></ion-icon>
    </ng-container>

    <ng-container *ngIf="product.isgroup !== true">
        <ion-icon *ngIf="!product.IsCatalog" uppDataid="product-thumb-available-mark" 
            class="floating top right" 
            name="checkmark-outline" 
            [ngClass]="(product.IsAvailable) ? 'success' : 'danger'"
        ></ion-icon>
    </ng-container>
</ng-template>

<ng-template #selecticons let-product="product">
    <ion-icon [uppDataid]="'product-thumb-check-' + (tr(product.name) || '') + '-button'" 
        [name]="(checked) ? 'checkmark-circle-outline' : 'radio-button-off-outline'" 
        class="floating top right check" [ngClass]="{ 'checked': checked }"
        [ngClass]="{ 'checked': checked }" 
        (click)="OnCheck()"
    ></ion-icon>  
</ng-template>

<ng-template #ticketicons let-product="product">
    <ion-icon *ngIf="product.IsGroup === true" class="floating top left warning" name="grid-outline"></ion-icon>

    <ng-container *ngIf="InCart > 0">
        <ion-chip class="cart right">
            <ion-label uppDataid="product-thumb-purchased-info">
                <ion-icon name="cart-outline"></ion-icon><span>{{InCart}}</span>
            </ion-label>
        </ion-chip>
    </ng-container>
</ng-template>

<upp-visible-control mode="content">
    <ng-container *ngIf="product !== null">
        <!-- DRAW THE PRODUCT / GROUP / FAMILY -->
        <ng-container *ngIf="(direct === null) && (target !== 'DIRECT')">
            <ng-container [ngTemplateOutlet]="productthumb" [ngTemplateOutletContext]="{ product: product }"></ng-container> 
        </ng-container>

        <!-- DRAW THE DIRECT / PRODUCT AS DIRECT -->
        <ng-container *ngIf="(direct !== null) || (target === 'DIRECT')">
            <ng-container *ngIf="direct !== null" [ngTemplateOutlet]="directthumb" [ngTemplateOutletContext]="{ product: direct }"></ng-container> 
            <ng-container *ngIf="direct === null" [ngTemplateOutlet]="directthumb" [ngTemplateOutletContext]="{ product: product }"></ng-container> 
        </ng-container>

        <!-- TARGET CREATE SPECIFIC ACTION -->
        <ng-container *ngIf="target === 'CREATE'">
            <ng-container [ngTemplateOutlet]="createicons" [ngTemplateOutletContext]="{ product: product }"></ng-container> 
        </ng-container>

        <!-- TARGET SELECT SPECIFIC ACTION -->
        <ng-container *ngIf="target === 'SELECT'">
            <ng-container [ngTemplateOutlet]="selecticons" [ngTemplateOutletContext]="{ product: product }"></ng-container> 
        </ng-container>

        <!-- TARGET TICKET SPECIFIC ACTION -->
        <ng-container *ngIf="((target === 'TICKET') || (target === 'DIRECT'))">
            <ng-container [ngTemplateOutlet]="ticketicons" [ngTemplateOutletContext]="{ product: product }"></ng-container> 
        </ng-container>
    </ng-container>

    <ng-container *ngIf="product === null">
        <ng-container [ngTemplateOutlet]="noproductthumb"></ng-container> 
    </ng-container>        
</upp-visible-control>

